import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  label: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.bold
  },
  input: {
    '& .MuiFormHelperText-root': {
      paddingBottom: '0'
    }
  },
  inputWithLabel: {
    minHeight: '82px'
  },
  characterLimit: {
    color: capitalDesignTokens.foundations.colors.gray800
  },
  asterisk: {
    color: capitalDesignTokens.foundations.colors.ruby500,
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.light
  }
});
